import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import Announcements from './Announcements';
import { useAnnouncements } from '@hooks/index';
import { compareStringsCaseInsensitively } from '@utils/miscellaneous/compareStrings';
import { languageTypes } from '@constants/common/languageTypes';
import { getLanguage } from '@reducers/appReducer';

function AnnouncementsContainer() {

    const { announcements, getAnnouncements } = useAnnouncements();
    const language = useSelector(getLanguage);

    useEffect(() => {
        getAnnouncements();
    }, []);

    const filteredAnnouncements = useMemo(() => {
        if (!announcements || announcements.length === 0) {
            return [];
        }

        const englishAnnouncements = announcements.filter(ann => 
            (ann.lookupLocale && compareStringsCaseInsensitively(ann.lookupLocale.localeCode, languageTypes.ENGLISH)) || 
            ann.lookupLocale === null
        );

        switch (language) {
            case languageTypes.ENGLISH:
                return englishAnnouncements;
            case languageTypes.SPANISH:
                return englishAnnouncements.map(engAnnouncement => {
                    const { announcementCode } = engAnnouncement;
                    const matchedAnnouncement = announcements.find(ann => 
                        ann.announcementCode === announcementCode && 
                        ann.lookupLocale && 
                        compareStringsCaseInsensitively(ann.lookupLocale.localeCode, languageTypes.SPANISH)
                    );
                    return matchedAnnouncement || engAnnouncement;
                });
            default:
                return englishAnnouncements;
        }
    }, [announcements, language]);

    if (filteredAnnouncements.length === 0) {
        return null;
    }

    return (
        <div className="announcements" data-testid="announcements-container">
            <Announcements announcements={filteredAnnouncements} />
        </div>
    );
}

export default AnnouncementsContainer;